module.exports = __webpack_public_path__ + "assets/hcaptcha.0ce5c855.svg";